var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlocked = function SvgBlocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3C6.20888 3 5.43552 3.2346 4.77772 3.67412C4.11992 4.11365 3.60723 4.73836 3.30448 5.46927C3.00173 6.20017 2.92252 7.00444 3.07686 7.78036C3.2312 8.55628 3.61216 9.26902 4.17157 9.82843C4.73098 10.3878 5.44372 10.7688 6.21964 10.9231C6.99556 11.0775 7.79983 10.9983 8.53073 10.6955C9.26164 10.3928 9.88635 9.88008 10.3259 9.22228C10.7654 8.56448 11 7.79112 11 7C11 6.47471 10.8965 5.95457 10.6955 5.46927C10.4945 4.98396 10.1999 4.54301 9.82843 4.17157C9.45699 3.80014 9.01604 3.5055 8.53073 3.30448C8.04543 3.10346 7.52529 3 7 3ZM7 10.2C6.15131 10.2 5.33738 9.86286 4.73726 9.26274C4.13714 8.66262 3.8 7.84869 3.8 7C3.79912 6.28934 4.03721 5.59902 4.476 5.04L8.96 9.524C8.40098 9.96279 7.71066 10.2009 7 10.2ZM9.524 8.96L5.04 4.476C5.59902 4.03721 6.28934 3.79912 7 3.8C7.84869 3.8 8.66263 4.13714 9.26274 4.73726C9.86286 5.33737 10.2 6.15131 10.2 7C10.2009 7.71066 9.96279 8.40098 9.524 8.96Z",
    fill: "#FF9900",
    stroke: "#FF9900",
    strokeWidth: 0.4
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blocked.06035a38.svg";
export { ForwardRef as ReactComponent };